/**
 * Safari viewport fix
 *
 * 1. Adds `safari-14-up` class to <body> on Safari 14+ (used by CSS overrides).
 * 2. On iPhone Safari, sets explicit height on `.safari-iphone-fix` elements to
 *    work around dynamic viewport sizing, and toggles body scroll lock when
 *    inputs receive focus to prevent layout shifts.
 *
 * Loaded with `defer` from layout/theme.liquid, so DOM is ready when this runs.
 */
(function () {
  'use strict';

  var ua = navigator.userAgent;
  var isSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Chromium') === -1;
  if (!isSafari) return;

  var versionMatch = ua.match(/Version\/(\d+)\.(\d+)/);
  if (versionMatch && parseInt(versionMatch[1], 10) >= 14) {
    document.body.classList.add('safari-14-up');
  }

  if (ua.indexOf('iPhone') === -1) return;

  function setDynamicHeight() {
    var vh = window.innerHeight;
    document.querySelectorAll('.safari-iphone-fix').forEach(function (el) {
      el.style.height = vh + 'px';
    });
  }

  setDynamicHeight();
  window.addEventListener('resize', setDynamicHeight);

  document.addEventListener('focusin', function (e) {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
      document.body.classList.add('active-input');
      document.body.style.overflow = 'hidden';
    }
  });

  document.addEventListener('focusout', function (e) {
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
      document.body.classList.remove('active-input');
      document.body.style.overflow = '';
    }
  });
})();
